.section {
  margin-block-start: var(--faq-margin-block-start, 60px);
}

.sectionTitle {
  color: var(--cxy-color-brand);
  font-size: 24px;
  font-weight: var(--cxy-fontWeight-bold);
  line-height: var(--cxy-lineHeight-xxl);
  margin-block-end: var(--faq-title-margin-block-end, var(--cxy-spacing-6));
  text-align: center;
}

.sectionDescription {
  color: var(--cxy-color-content-default);
  font-size: var(--cxy-fontSize-m);
  font-weight: var(--cxy-fontWeight-medium);
  line-height: 18px;
  text-align: center;
  margin-block-end: var(--faq-subtitle-margin-block-end, var(--cxy-spacing-7));
}

.accordionContent + .accordionContent {
  margin-block-start: var(--cxy-spacing-5);
}

.link {
  font-weight: var(--cxy-fontWeight-bold);
  font-size: inherit;
  line-height: inherit;
  text-decoration: underline;
}
.link,
.link:hover,
.link:visited {
  color: var(--cxy-color-content-default);
}

[data-fpsm-theme='gazzetta'] {
  .sectionTitle {
    font-size: var(--cxy-fontSize-xxl);
  }
  .sectionDescription {
    font-size: var(--cxy-fontSize-m);
  }

  @media (--cxy-tablet-wide) {
    .sectionTitle {
      font-size: 36px;
    }
    .sectionDescription {
      font-size: var(--cxy-fontSize-m);
    }
  }
}
